<template>
  <div class="popup affirm-custom-modal">
    <Modal ref="modal" class="content-popup" :show.sync="show" :show-close="true">
      <div class="affirm-modal-container">
        <div class="affirm-modal-content-body">
          <iframe scrolling="no" :src="url" frameborder="0" class="affirm_iframe"></iframe>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { Modal } from '@article/pixel';

export default {
  name: 'AffirmModal',
  components: {
    Modal,
  },
  props: {
    url: {
      type: String,
      default: '',
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: false,
      loaded: false,
      iframeLoaded: false
    };
  },

  mounted() {
    window.addEventListener('message', this.onAffirmModalEvent);
  },
  destroyed() {
    window.removeEventListener('message', this.onAffirmModalEvent);
  },
  watch: {
    showModal: {
      handler(value, oldValue) {
        if (value) {
          this.show = true;
        }
      },
    },

    show: {
      handler(value, oldValue) {
        document.getElementById('app').style.overflow = 'hidden';
        if (!value) {
          this.loaded = false;
          this.iframeLoaded = false;
          this.$emit('onClose');
          document.getElementById('app').style.overflow = 'unset';
        }
      },
    },
  },

  methods: {
    load() {
      this.loaded = true;
    },
    onAffirmModalEvent(event) {
      if(this.url && event.origin === new URL(this.url).origin) {
        try{
          const data = JSON.parse(event.data);
          if(data.id === 'AFFIRM_FRAME_MESSAGES' && data.name === 'iframe-ready') {
            if(this.iframeLoaded) {
              // this is a bit hacky, but affirm does not fire event for modal close.
              // we treat "second" loaded event as close event, since all navigcation within flow does not fire this loaded event, 
              // but clicking on any close button will refresh the iframe hence fire another loaded event.
              this.show = false;
            }else{
              this.iframeLoaded = true;
            }
          }
        } catch(e) {}
      }
    },
  },
};
</script>

<style lang="scss">
@import '~@article/pixel/dist/style/variables';

.popup {
  &.affirm-custom-modal {
    // min-height: 800px;
    .af.af-close {
      position: absolute;
      color: transparent;
      left: 0;
      width: 30px;
      height: 40%;
      max-height: 145px;;
    }
    .body{
      padding: 0;
    }
  }
  .popup-image-tile {
    cursor: pointer;
  }
}

.paybright-learn-more {
  text-align: right;
  text-transform: none;
  display: block;
  line-height: initial;
  margin-left: 29px;
  font-size: $secondary-font-size;
}

.content-popup {
  @media (max-width: $extra-small-breakpoint) {
    .body {
      padding: var(--padding) 0px;
    }
  }
  .body {
    min-height: 800px;
    height: 100%;
  }

  .affirm-modal-container {
    background-color: #fefefe;
    padding: 0;
    height: 100%;
    width: 550px;

    @media (max-width: $mobile-breakpoint - 1) {
      width: 100%;
    }

    .affirm-modal-content-body {
      height: 100%;

      .affirm_iframe {
        background-color: white;
        height: inherit;

        @media (min-width: $extra-small-breakpoint) {
          width: 100%;
        }
      }

      .loader-container {
        height: inherit;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}
</style>
